export const BLACKDUCK_ANNOTATION = 'synopsys.com/project-key';
export const BLACKDUCK_BACKEND_BASE_URL = '/blackduck';
export const BLACKDUCK_PLUGIN_ID = 'blackduck';
export const NOT_FOUND = 'not found';
